import { LicenseInfo } from '@mui/x-license';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as Sentry from '@sentry/react';
import { runtimeEnv } from './config/runtimeEnv';

Sentry.init({
  dsn: runtimeEnv.sentryDsn,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: runtimeEnv.environment,
});

if (runtimeEnv.muiXLicenseKey) {
  LicenseInfo.setLicenseKey(runtimeEnv.muiXLicenseKey);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
